import React from "react";
import "../styles/About.css";

const About = () => {
  return (
    <section className="about section" id="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <p className="about-text">
          I'm Mythili Aitha, a full-stack developer with a Master's in Computer
          Science from the University of Houston. I specialize in building
          scalable web applications and cloud-based solutions using technologies
          like React, Java, Spring Boot, and AWS. With hands-on experience as a
          Web Developer at UH and a Software Developer at Agile Solutions, I've
          worked on projects ranging from university websites and eCommerce
          platforms to AI-powered systems and serverless apps. I'm passionate
          about turning complex problems into user-friendly, impactful
          solutions.
        </p>
      </div>
    </section>
  );
};

export default About;
